module.exports = __webpack_public_path__ + "img/agree.5a14228b.svg";